<template>
    <div id="comment-manage">
      <!--搜索-->
      <div class="top">
        <el-col :span="12">
          <el-input placeholder="请输入内容" v-model="input" class="input-with-select" style="width: 100%">
            <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
          </el-input>
        </el-col>
        <el-col :span="2" :offset="1">
        </el-col>
      </div>
      <!--表格-->
      <div class="comment-table">
        <el-table
          border
          :data="tableData"
          style="width: 100%">
          <el-table-column
            label="订单 ID"
            align="center"
            width="100"
            prop="id">
          </el-table-column>
          <el-table-column
            label="订单编号"
            align="center"
            width="120"
            show-overflow-tooltip
            prop="out_trade_no">
          </el-table-column>
          <el-table-column
            label="联系方式"
            align="center"
            show-overflow-tooltip
            prop="phone">
          </el-table-column>
          <el-table-column
            label="下单时间"
            align="center"
            show-overflow-tooltip
            prop="created">
          </el-table-column>
          <el-table-column
            label="订单金额"
            width="80"
            align="center"
            prop="price">
          </el-table-column>
          <el-table-column
            label="订单状态"
            align="center"
            show-overflow-tooltip
            prop="status_type">
            <template #default="{ row }">
            <span :style="{ color: getStatusColor(row.status) }">
              {{ getStatusText(row.status) }}
            </span>
      </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="block" v-if="tableData.length">
        <el-pagination
          @current-change="currentChange"
          background
          layout="prev, pager, next"
          :page-size="8"
          :page-count="total">
        </el-pagination>
      </div>
    </div>
</template>

<script>
    import {MessageBox,Message} from 'element-ui'
    import {getComments,deleteComment} from '../../../api/index'
    import moment from 'moment'
    export default {
        name: "CommentManage",
        data() {
          return {
            tableData:[],
            total:0,
            currentPage:1,
            dialogFormVisible:false,
            dialogTitle:'',
            labelPosition:'left',
            input:'',
            searchInput:'',
          }
        },
        created(){
          this.loadCurrentPageComment(this.currentPage,8,'');
        },
        methods: {
          getStatusColor(status) {
      if (status === '1') {
        return 'green';
      } else if (status === '0') {
        return 'orange';
      } else {
        return 'red';
      }
          },
          getStatusText(status) {
            if (status === '1') {
              return '已完成';
            } else if (status === '0') {
              return '待处理';
            } else {
              return '异常';
            }
          },

          async loadCurrentPageComment(currentPage,pageSize,input){
            let json = await getComments(currentPage,pageSize,input);
            if (json.code===200){
              this.tableData = json.result;
              this.tableData.forEach(value => {
                value.created = moment(value.created).format('YYYY-MM-DD HH:mm:ss');
                value.price = value.price /1000;
                
              });

              this.total = Math.ceil(json.total / 10);
            }
          },
          async currentChange(currentPage){
            this.currentPage = currentPage;
            this.loadCurrentPageComment(this.currentPage,8,this.searchInput);
          },
          //搜索评论
          search(){
            this.searchInput = this.input;
            this.loadCurrentPageComment(1,8,this.searchInput);
          },
          // async handleEdit(index, row) {
          //   console.log(index, row);
          //   let json = await passCurrentComment(row.comment_id,row.movie_id);
          //   if (json.success_code===200){
          //     this.loadCurrentPageComment(this.currentPage,8,this.searchInput);
          //     Message.success('评论审核通过！');
          //   }
          // },
          async handleDelete(index, row) {
            console.log(index, row);
            MessageBox.confirm('此操作将永久删除该评论所有信息, 是否继续？','提示').then(async (value)=>{
              if (value==='confirm'){
                let json = await deleteComment(row.id);
                if (json.state===200){
                  this.loadCurrentPageComment(this.currentPage,8,this.searchInput);
                  Message.success('删除该评论成功！');
                }
              }
            });
          }
        },
    }
</script>

<style>
  .comment-table{
    width:90%;
    min-width:900px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .top{
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 30px 0; */
    margin-bottom: 30px;
  }
  .block{
    text-align: center;
  }
  .el-dialog__header{
    text-align: center;
  }
  .el-dialog__body .el-form-item{
    padding-left: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/children/CommentManage.vue